module.exports = __webpack_public_path__ + "img/chelsea.d854acff.png";